export const PaymentMethod = {
  BANK_TRANSFER: 'bank_transfer',
  SEPA_DIRECT_DEBIT: 'direct_debit_mandate'
};

export const PAYMENT_METHODS = Object.values(PaymentMethod);

export default PaymentMethod;
